<template>
    <div class="bannerNode">
        <!-- <top-tab
            :topBarDatas="topBarDatas"
        ></top-tab> -->
        <div class="contentBox">
            <box-border
                :title="`采办概览/技术评标状态 ( 共${MajorTrackOne.allDatas}个采办包 )`"
                :childBoxStyle="{
                    display: 'flex'
                }"
            >
                <echart-module
                    ref="MajorTrackOne"
                    style="width: 50%;"
                    :option="MajorTrackOne"
                ></echart-module>
                <echart-module
                    ref="MajorTrackTwo"
                    style="width: 50%;"
                    :option="MajorTrackTwo"
                ></echart-module>
            </box-border>
            <box-border
                title="采办分析"
                :boxStyle="{
                    'grid-row': '1 / span 3',
                    'grid-column': '2 / span 1'
                }"
            >
                <Table
                    v-bind="PurchaseAnalysis"
                    :tableStyle="{
                        height: '100%'
                    }"
                    :tbodyStyle="{
                        'text-align': 'left'
                    }"
                >
                </Table>
            </box-border>
            <box-border
                title="采办步骤跟踪"
            >
                <echart-module
                    ref="PurchaseStepsTrack"
                    :option="PurchaseStepsTrack"
                ></echart-module>
            </box-border>
            <box-border
                title="采办步骤偏差"
            >
                <echart-module
                    ref="StepsVar"
                    :option="StepsVar"
                ></echart-module>
            </box-border>
            <!-- <box-border
                title="货物跟踪"
            >
                <Table
                    v-bind="CargoTrack"
                    :tableStyle="{
                        height: '100%',
                    }"
                >
                </Table>
            </box-border> -->
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PurchaseTwo',
        data(){
            return {
                MajorTrackOne: {
                    color: [0,1,2,3,4],
                    legend: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function(params){
                            let htmls = params.seriesName + '<br/>';
                            htmls += params.marker + params.data.s1 + '&nbsp&nbsp' + params.value;
                            return htmls;
                        }
                    }
                },
                MajorTrackTwo: {
                    color: [0,1,2,3,4],
                    legend: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function(params){
                            let htmls = params.seriesName + '<br/>';
                            htmls += params.marker + params.data.s1 + '&nbsp&nbsp' + params.value;
                            return htmls;
                        }
                    }
                },
                topBarDatas: [
                    {
                        name: 'Overall',
                        fn: () => {
                            this.stype = 'Project';
                            this.renderFn();
                        }
                    },
                    {
                        name: 'CPF & Wellpad & IFL',
                        fn: () => {
                            this.stype = 'CPF & Wellpad & IFL';
                            this.renderFn();
                        }
                    },
                    {
                        name: 'Temporary Camp',
                        fn: () => {
                            this.stype = 'TCP';
                            this.renderFn();
                        }
                    },
                    {
                        name: 'WIS',
                        fn: () => {
                            this.stype = 'WIS';
                            this.renderFn();
                        }
                    }
                ],
                //采办步骤跟踪
                PurchaseStepsTrack: {
                    grid: {
                        top: '15%',
                        right: '2%'
                    },
                    color: [1, 0],
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].data.s1} <br />`;
                            datas.forEach((item) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                            })
                            return html;
                        }
                    },
                },
                //采办步骤偏差
                StepsVar: {
                    color: [3],
                    grid: {
                        top: '15%',
                        right: '2%'
                    },
                    yAxis: {
                        splitNumber: 4
                    },
                    tooltip: {
                        formatter: (datas) => {
                            // this.StepsVar.nowClickName = datas[0].data.s1;
                            let html = `${datas[0].data.s1} <br />`;
                            datas.forEach((item) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                            })
                            return html;
                        }
                    },
                    // getZrFn: async (params) => {
                    //     const pointInPixel = [params.offsetX, params.offsetY];
                    //     if(this.$refs.StepsVar.myChart.containPixel('grid', pointInPixel)){
                    //         //改变表格数据
                    //         const data = await this.getTableData('8acba68d82d9ba070182f273d1990059', 'VAR-' + this.StepsVar.nowClickName);
                    //         this.PurchaseAnalysis = data;
                    //     }
                    // }
                },
                //采办分析
                PurchaseAnalysis: {

                },
                //Cargo Tracking
                CargoTrack: {

                },
                stype: 'Project'
            }
        },
        // async mounted() {
        //     //Cargo Tracking
        //     const data = await this.getTableData('8acba68d82d9ba070182f28201db005a', 0);
        //     this.CargoTrack = data;
        // },
        mounted() {
            this.renderFn();
        },
        methods: {
            renderFn(){
                const getxhrArr = [
                    //采办步骤跟踪
                    async() => {
                        this.getNewVTos(
                            {
                                id: '2c92808382e7577c0182ed47a7430003',
                                stype: this.stype
                            },
                            [
                                ['计划', '实际'],
                                ['bar', 'bar']
                            ],
                            this.$refs.PurchaseStepsTrack.myChart,
                            {
                                name: 'PurchaseStepsTrack',
                                startIndex: 2,
                                hasMoreData: ['s1', 's4'],
                                label: true,
                                clickFn: (value) => {
                                    if(value.componentIndex == 0){
                                        //计划
                                        this.getPurchaseAnalysis('PLAN-' + value.data.s1);
                                    }else{
                                        //实际
                                        this.getPurchaseAnalysis('ACT-' + value.data.s1);
                                    }
                                }
                            }
                        )
                    },
                    //采办步骤偏差
                    async() => {
                        this.getNewVTos(
                            {
                                id: '8acba68d82d9ba070182f230985c0058',
                                stype: this.stype
                            },
                            [
                                ['偏差'],
                                ['bar']
                            ],
                            this.$refs.StepsVar.myChart,
                            {
                                name: 'StepsVar',
                                startIndex: 2,
                                hasMoreData: ['s1'],
                                label: true,
                                clickFn: (value) => {
                                    this.getPurchaseAnalysis('VAR-' + value.data.s1);
                                }
                            }
                        )
                    },
                    //采办概览
                    async () => {
                        this.getPieVosData(
                            {
                                id: '8acba68d82d9ba070182f1e866e4004c',
                                stype: this.stype
                            },
                            '数量',
                            this.$refs.MajorTrackOne.myChart,
                            {
                                name: 'MajorTrackOne',
                                otherKeys: ['s1'],
                                fromIndex: 2,
                                clickFn: (data) => {
                                    this.getPurchaseAnalysis('STEP-' + data.data.s1);
                                }
                            },
                            (res) => {
                                let num = 0;
                                res.s2.forEach(item => {
                                    num += Number(item);
                                })
                                this.MajorTrackOne.allDatas = num;
                            }
                        )
                    },
                    async () => {
                        this.getPieVosData(
                            {
                                id: '8acba68d82d9ba070182f28201db005a',
                                stype: this.stype
                            },
                            '数量',
                            this.$refs.MajorTrackTwo.myChart,
                            {
                                name: 'MajorTrackTwo',
                                otherKeys: ['s1'],
                                fromIndex: 2,
                                clickFn: (data) => {
                                    this.getPurchaseAnalysis('DISP-' + data.data.s1);
                                }
                            }
                        )
                    },
                    //采办分析
                    async () => {
                        this.getPurchaseAnalysis(this.stype);
                    },
                ];
                this.getAllPromise(getxhrArr);
            },
            //采办分析偏差
            async getPurchaseAnalysis(stype){
                const data = await this.getTableData('8acba68d82d9ba070182f273d1990059', stype);
                this.PurchaseAnalysis = data;
            }
        },
    }
</script>
<style lang="less" scoped>
    .contentBox{
        height: 100%;
        width: 100%;
        .gridStyle(2, 3, 0.24rem, 0.1rem);
    }
</style>